import {type IAsset} from '@netx/core-asset-next/schema';
import {type IConstituentClip} from '../schema';
import {canManageConstituentClips} from './canManageConstituentClips';

export const canManageConstituentClip = (
	asset?: IAsset,
	constituentClip?: IConstituentClip,
) => {
	return canManageConstituentClips(asset, constituentClip);
};
